import axios from "axios";
import { APIS } from "../../../../../utils/api-factory";
import { POST_HEADER } from "../../../../../utils/apiHeaders";

export const GetEmployeeToRule = (callback, error) => {
    axios.get(APIS.GET_EMPLOYEE_TO_RULE)
        .then(res => {
            callback(res?.data)
        })
        .catch(e => {
            callback("")
        })
}

export const GetEmployeeToRuleByEmployeeId = (id, callback, error) => {
    axios.get(APIS.GET_EMPLOYEE_TO_RULE_BY_EMPLOYEEID + id)
        .then(res => {
            callback(res?.data)
        })
        .catch(e => {
            callback("")
        })
}

export const DeleteEmployeeToRuleById = (id, callback, error) => {
    axios.delete(APIS.DELETE_EMPLOYEE_TO_RULE_BY_ID + id)
        .then(res => {
            callback(res)
        })
        .catch(e => {
            callback("")
        })
}

export const SaveEmployeetoRule = (data, callback, error) => {
    const headerconfig = {
        header: POST_HEADER
    }
    axios.post(APIS.SAVE_EMPLOYEE_TO_RULE, data, headerconfig)
        .then(res => {
            callback(res?.data)
        })
        .catch(e => {
            callback("")
        })
}

export const getAllrulesList = (callback, error) => {
    axios.get(APIS.GET_ALL_RULES_LIST)
        .then(res => {
            callback(res?.data)
        })
        .catch(e => {
            callback("")
        })
}

export const getAllrulesListByRuleId = (id, callback, error) => {
    axios.get(APIS.GET_ALL_RULES_LIST_BY_RULEID + id)
        .then(res => {
            callback(res?.data)
        })
        .catch(e => {
            callback("")
        })
}

export const DeleteRuleByRuleId = (id, callback, error) => {
    axios.delete(APIS.DELETE_RULE_BY_RULEID + id)
        .then(res => {
            callback(res)
        })
        .catch(e => {
            callback("")
        })
}

export const SaveRulesByData = (data, callback, error) => {
    const headerconfig = {
        header: POST_HEADER
    }
    axios.post(APIS.SAVE_RULES_BY_DATA, data, headerconfig)
        .then(res => {
            callback(res?.data)
        })
        .catch(e => {
            callback("")
        })
}

export const activateDeactivateRuleByType = (id, type, callback, error) => {
    axios.patch(APIS.ACTIVATE_DEACTIVATE_RULES_BY_ID + id + "/" + type)
        .then(res => {
            callback(res?.data)
        })
        .catch(e => {
            callback("")
        })
}

export const UpdateRulesbyRuleId = (id, data, callback, error) => {
    const headerconfig = {
        header: POST_HEADER
    }
    axios.put(APIS.UPDATE_RULES_BY_RULEID + id, data, headerconfig)
        .then(res => {
            callback(res?.data)
        })
        .catch(e => {
            callback("")
        })
}